import React, { Component } from 'react';
import scriptLoader from 'react-async-script-loader';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Button } from '../../base/buttons/buttons';
import './subscriptionModal.css';

//TODO: check
// - https://stackoverflow.com/questions/44341293/custom-mailchimp-signup-form-in-react
// - https://github.com/revolunet/react-mailchimp-subscribe
// - https://www.npmjs.com/package/react-mailchimp-form

class SubscriptionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  handleToggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  }

  render() {
    const { isOpen } = this.state;
    const styDisplayNone = { display: 'none' };
    const styTranslateLeft = { position: 'absolute', left: '-5000px' };
    return (
      <React.Fragment>
        <Button
          onClick={this.handleToggle}
          theme="light"
          content="Subscribe to the inner circle"
        />
        <Modal isOpen={isOpen} toggle={this.handleToggle} className="subscription-modal">
          <ModalHeader toggle={this.handleToggle}>
            <span className="subscription-modal--header">Subscribe to the inner circle</span>
          </ModalHeader>
          <ModalBody>
            <div id="mc_embed_signup">
              <form
                action="https://facebook.us17.list-manage.com/subscribe/post?u=ad535fe200925d6d4529fe5c1&amp;id=446f5a9a49"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                className="validate"
                target="_blank"
                noValidate
              >
                <div id="mc_embed_signup_scroll">
                  <div className="indicates-required">
                    <span className="asterisk">*</span> indicates required
                  </div>
                  <div className="mc-field-group">
                    <label htmlFor="mce-EMAIL">E-Mail<span className="asterisk">*</span></label>
                    <input
                      type="email"
                      defaultValue=""
                      name="EMAIL"
                      className="required email"
                      id="mce-EMAIL"
                      aria-describedby="emailDescription"
                    />
                    <small id="emailDescription" className="form-text text-muted">
                      We'll never share your email with anyone else.
                    </small>
                  </div>
                  <br/>
                  <div><strong>Optional information</strong></div>
                  <br/>
                  <div className="mc-field-group">
                    <label htmlFor="mce-FNAME">First name</label>
                    <input type="text" defaultValue="" name="FNAME" className="" id="mce-FNAME" />
                  </div>
                  <div className="mc-field-group">
                    <label htmlFor="mce-LNAME">Last name</label>
                    <input type="text" defaultValue="" name="LNAME" className="" id="mce-LNAME" />
                  </div>
                  <div className="mc-field-group">
                    <label htmlFor="mce-MMERGE3">Website</label>
                    <input type="url" defaultValue="" name="MMERGE3" className=" url" id="mce-MMERGE3" />
                  </div>
                  <div className="mc-field-group">
                    <label htmlFor="mce-MMERGE4">About you</label>
                    <input type="text" defaultValue="" name="MMERGE4" className="" id="mce-MMERGE4" />
                  </div>
                  <div id="mce-responses" className="clear">
                    <div className="response" id="mce-error-response" style={styDisplayNone}></div>
                    <div className="response" id="mce-success-response" style={styDisplayNone}></div>
                  </div>
                  <div style={styTranslateLeft} aria-hidden="true">
                    <input
                      type="text"
                      name="b_ad535fe200925d6d4529fe5c1_446f5a9a49"
                      tabIndex="-1"
                      defaultValue=""
                    />
                  </div>
                  <div className="clear">
                    <input
                      type="submit"
                      value="Subscribe"
                      readOnly
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      className="button"
                    />
                  </div>
                </div>
              </form>
            </div>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default scriptLoader(
  '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'
)(SubscriptionModal)

